import { Card, Divider } from "@dash/page";
import { useTheme } from "@emotion/react";
import React from "react";
import { MdOutlineMailOutline } from "react-icons/md";

import { SupportTicketMessageBody } from "./SupportTicketMessageBody";
import { SupportTicketMessageAttachments } from "./SupportTicketMessageAttachments";

import type { MessageDto } from "@megaron/support-contracts";
import type { Uuid } from "@megaron/uuid";

type Props = {
  ticketId: Uuid;
  messageId: Uuid;
  fromName: string;
  fromEmail: string;
  time: string;
  body: string;
  isOutgoing: boolean;
  attachments: MessageDto["attachments"];
};

export const SupportTicketEmailEntry: React.FC<Props> = ({
  ticketId,
  messageId,
  fromName,
  fromEmail,
  time,
  body,
  isOutgoing,
  attachments,
}) => {
  const theme = useTheme();

  return (
    <Card variant="secondary" color={isOutgoing ? theme.colors.primary : theme.colors.border}>
      <div css={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "0.75rem" }}>
        <div css={{ display: "flex", alignItems: "flex-start", gap: "0.625rem", minWidth: 0 }}>
          <div css={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
            <div css={{ display: "flex", alignItems: "center", gap: "0.375rem" }}>
              <MdOutlineMailOutline
                size={13}
                css={{ color: theme.colors.primary, opacity: 0.5, flexShrink: 0 }}
              />
              <span css={{ fontSize: "13px", fontWeight: 600, color: theme.colors.primary }}>{fromName}</span>
            </div>
            <span css={{ fontSize: "11px", opacity: 0.55, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {fromEmail}
            </span>
          </div>
        </div>
        <span css={{ fontSize: "11px", opacity: 0.55, whiteSpace: "nowrap", flexShrink: 0 }}>{time}</span>
      </div>
      <Divider />
      <SupportTicketMessageBody body={body} />
      <SupportTicketMessageAttachments ticketId={ticketId} messageId={messageId} attachments={attachments} />
    </Card>
  );
};
